@if (permissionService.canLogistAddDevices$ | async) {
  <div [formGroup]="formGroup">
    <div class="x-input-label">
      {{ 'request_form.devices.update_device.sim_1' | translate }}
    </div>
    <div class="flex flex-col">
      <tui-textfield
        iconStart="@tui.plus"
        class="x-textfield-icon-s"
        [tuiTextfieldCleaner]="true"
      >
        <input [formControlName]="FormFields.Sim1" tuiInput />
      </tui-textfield>
      <tui-error [formControlName]="FormFields.Sim1"></tui-error>
    </div>

    <div class="x-input-label">
      {{ 'request_form.devices.update_device.sim_2' | translate }}
    </div>
    <div class="flex flex-col">
      <tui-textfield
        iconStart="@tui.plus"
        class="x-textfield-icon-s"
        [tuiTextfieldCleaner]="true"
      >
        <input [formControlName]="FormFields.Sim2" tuiInput />
      </tui-textfield>
      <tui-error [formControlName]="FormFields.Sim2"></tui-error>
    </div>

    <x-request-device-protective-case-input
      [patchValue]="device"
      [formControlName]="FormFields.ProtectiveCaseSubform"
    ></x-request-device-protective-case-input>
  </div>
  <div class="flex justify-end mt-5 gap-5">
    <button
      tuiButton
      appearance="secondary"
      type="button"
      size="m"
      (click)="cancelUpdateRequestDevice()"
    >
      {{ 'request_form.devices.update_device.button_cancel' | translate }}
    </button>
    <button
      tuiButton
      type="button"
      size="m"
      (click)="updateRequestDevice$.next()"
      [class.cursor-not-allowed]="formGroup.invalid"
      [class.cursor-pointer]="formGroup.valid"
      [disabled]="formGroup.invalid"
    >
      {{ 'request_form.devices.update_device.button_save' | translate }}
    </button>
  </div>
}
